document.addEventListener('DOMContentLoaded', () => {
  const variantEl = document.querySelector('[data-variant-id]');
  const quantityEl = document.querySelector('.product__quantity #quantity');
  const addToCart = document.querySelector('[js-add-to-cart]');

  const select = document.querySelector('.single-option-selector');
  const hiddenInput = document.querySelector('input[data-variant-id]');
  const productDefaultPrice = document.querySelector('.product__price');

  if (select && hiddenInput && productDefaultPrice) {
    select.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const selectedValue = selectedOption.value;
      const selectedPrice = selectedOption.getAttribute('option-price');

      hiddenInput.setAttribute('data-variant-id', selectedValue);
      hiddenInput.value = selectedValue;

      if (selectedPrice) {
        const formattedPrice = selectedPrice;
        productDefaultPrice.textContent = formattedPrice;
      }
    });
  }

  async function updateCartCount() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const headerIconCart = headerWrapper.querySelector('.header__icon.header__icon--cart');

    const sectionId = headerWrapper?.getAttribute('id');
    const currnetDomain = window.location.hostname;
    const fetchUrl = `https://${currnetDomain}/?section_id=${sectionId}`;

    try {
      const response = await fetch(fetchUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newHeaderWrapper = doc.querySelector('.header-wrapper');
      const newHeaderIconCart = newHeaderWrapper.querySelector('.header__icon.header__icon--cart');

      if (newHeaderWrapper && newHeaderIconCart) {
        headerIconCart.innerHTML = newHeaderIconCart.innerHTML;
      }
      addToCart.innerHTML = 'Add to basket';
    } catch (error) {
      addToCart.innerHTML = 'Add to basket';
      console.error('Error fetching header section:', error);
    }
  }

  async function updateAndShowCartDrawer(maxRetries = 60, delay = 500) {

    const cartDrawer = document.querySelector('cart-drawer');
    if(!cartDrawer) return;


    cartDrawer.classList.remove('is-empty');
    cartDrawer.classList.add('animate');
    const fetchUrl = '/cart';
    const tryFetchCart = async (retriesLeft) => {
      try {
        const response = await fetch(fetchUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');

        if (!newCartDrawer.classList.contains('is-empty')) {
          // Cart is not empty, update the drawer and show it
          cartDrawer.querySelector('#CartDrawer').innerHTML = newCartDrawer.querySelector('#CartDrawer').innerHTML;
          cartDrawer.classList.remove('is-empty');
          cartDrawer.classList.add('active');
          addToCart.innerHTML = 'Add to basket';
        } else if (retriesLeft > 0) {
          // Cart is still empty, retry after a delay
          await new Promise((resolve) => setTimeout(resolve, delay));
          await tryFetchCart(retriesLeft - 1);
        } else {
          // Max retries reached, handle as error or fallback
          cartDrawer.innerHTML = newCartDrawer.innerHTML; // Update anyway
          cartDrawer.classList.add('active');
          addToCart.innerHTML = 'Add to basket';
        }
      } catch (error) {
        console.error('Error fetching cart:', error);
        addToCart.innerHTML = 'Add to basket';
      }
    };

    await tryFetchCart(maxRetries);
  }

  if (addToCart) {
    addToCart.addEventListener('click', async (e) => {
      e.preventDefault();

      const thisButton = e.currentTarget;
      const productForm = thisButton.closest('form');
      const variantEl = productForm.querySelector('[data-variant-id]');

      const vId = variantEl?.value;
      if (vId === '') {
        alert('Please select options.');
        return;
      }

      const quantity = quantityEl?.value;
      const productData = {
        items: [
          {
            id: Number(vId),
            quantity: Number(quantity),
          },
        ],
      };

      addToCart.innerHTML = 'Adding to basket';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(productData),
        });
        if (!res.ok) throw new Error('Failed to add to cart');
        await res.json(); // Parse response
        await updateCartCount();
        // await updateAndShowCartDrawer();
      } catch (e) {
        console.error('Error adding to cart:', e);
        addToCart.innerHTML = 'Add to basket';
      }
    });
  }
});